<template>
  <p>Log in successful. Please hold.</p>
</template>

<script>
export default {};
</script>
